import React from 'react';

export function SearchIcon() {
  // https://lucide.dev/icons/search
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m21 21-4.34-4.34" />
      <circle cx="11" cy="11" r="8" />
    </g>
  );
}
